// 公共
export const SupplyRouterName = {
  /** 售后单 */
  AfterSales: '/supply/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/supply/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/supply/after_sales/detail',
  /**
   * 售后单编辑
   */
  AfterSalesEdit: '/supply/after_sales/edit',
  /**
   * 售后单打印
   */
  AfterSalesPrint: '/supply/after_sales/print',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/supply/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/supply/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/supply/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/supply/inquiry_quotation/discount_price/detail',

  /** 商品行情价 */
  MarketPriceList: '/supply/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/supply/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/supply/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/supply/inquiry_quotation/market_price/create',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/supply/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/supply/report/discount_price_public/result',

  /** 司机绩效 */
  DriverPerformanceList: '/supply/driver_performance/list',

  /** 行车报警 */
  VehicleAlarmList: '/supply/vehicle_alarm/list',

  /** 配送任务 */
  ManageDeliveryTaskList: '/supply/delivery_task/list',

  /** 合同详情 */
  PublicPurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',

  /** 现场监控 */
  LiveMonitor: '/supply/live_monitor/list',
  /** 现场监控全屏 */
  LiveMonitorFullScreen: '/supply/live_monitor/full_screen',
  /** 违规记录 */
  VolationRecordList: '/supply/live_monitor/violation_record/list',
  PurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',

  /** 执行台账记录 */
  ExecutionRecordList: '/supply/execution_record/list',
  /** 执行台账记录详情 */
  ExecutionRecordDetail: '/supply/execution_record/detail',

  /** 验收标准详情 */
  AcceptanceCriteriaDetail: '/supply/acceptance_criteria/detail',

  /** 采购评价 */
  PurchaseEvaluateList: '/supply/report/purchase_evaluate/list',
  /** 采购单 */
  PurchaseOrderList: '/supply/purchase_order/list',
  /** 整改记录 */
  RectificationRecordList: '/supply/rectification_record/list',
  /** 售后明细 */
  AfterSaleDetailReportList: '/supply/report/after_sale_detail_report/list',
  /** 对账明细表 */
  StatementDetailReportList: '/supply/report/statement_detail_report/list',
  /** 查看答卷 */
  ExaminationExamAnswerDetail: '/supply/examination/exam_answer_detail',
  /** 答题 */
  ExaminationExamAnswer: '/supply/examination/exam_answer',
  /** IO记录 */
  IoRecordList: '/supply/io_record/list',
};
